import { render, staticRenderFns } from "./SettingList.vue?vue&type=template&id=4ae951a2&"
import script from "./SettingList.ts?vue&type=script&lang=js&"
export * from "./SettingList.ts?vue&type=script&lang=js&"
import style0 from "./SettingList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports